import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'

import { ModifyEventSchema } from '../../events/Events.schema'

interface Props {
  data: ReturnType<typeof ModifyEventSchema.safeParse> | null
}

export function ErrorParsingDataCalendar({ data }: Props) {
  const { t } = useTranslation('events')
  const { eventId } = useParams()
  const navigate = useNavigate()

  const { getValues } = useFormContext<ModifyEventSchema>()

  return data && 'data' in data && data.success ? null : (
    <Stack>
      <Typography color="error">
        {t("Une erreur est survenue lors de l'affichage des données")}
      </Typography>
      {data && 'error' in data ? (
        <ul>
          {data.error.issues.map(issue => (
            <>
              <li>
                <strong>{`${issue.path.toString()}`}</strong>
                {` : ${issue.message}`}
                <button
                  onClick={event => {
                    event.preventDefault()
                    if (issue.path[0] === 'event') {
                      navigate(`/admin/events/${eventId}/event`)
                    }
                    if (issue.path[0] === 'sessions') {
                      const id = getValues(`sessions.${Number(issue.path[1])}.id`)
                      navigate(`/admin/events/${eventId}/sessions/${id}`)
                    }
                    if (issue.path[0] === 'subEvents') {
                      const id = getValues(`subEvents.${Number(issue.path[1])}.id`)
                      navigate(`/admin/events/${eventId}/sessions/subEvent/${id}`)
                    }
                    if (issue.path[0] === 'options') {
                      const id = getValues(`options.${Number(issue.path[1])}.id`)
                      navigate(`/admin/events/${eventId}/conditions?options=${id}`)
                    }
                  }}
                >
                  {t('Modifier')}
                </button>
              </li>
              {'unionErrors' in issue && (
                <ul>
                  {issue.unionErrors.map(unionErr =>
                    unionErr.issues.map(el => (
                      <li>
                        <strong>{`${el?.path?.toString()}`}</strong>
                        {` : ${el?.message}`}{' '}
                      </li>
                    ))
                  )}
                </ul>
              )}
            </>
          ))}
        </ul>
      ) : null}
    </Stack>
  )
}
